import React from "react";
import "./styles.css";

const H2 = ({ className = "", children, isBlog }) => (
  <h2 className={`H2 ${className} ${isBlog ? "blog" : ""}`}>{children}</h2>
);

export default H2;



/** WEBPACK FOOTER **
 ** ./src/views/components/h2/index.js
 **/